import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

// import GetLocale from '../../assets/content';
import chatIcon from "../../images/bt_chat.svg";
import elecboyChatIcon from "../../images/elecboy/chat-icon.svg";
import treChatIcon from "../../images/tre/chat-icon.svg";
import epicChatIcon from "../../images/epic/chat.svg";
import hcChatIcon from "../../images/homecredit/PH/chat-icon.svg";
import samsungChatIcon from "../../images/samsung/chat-icon.svg";
import shopeeChatIcon from "../../images/shopee/chat-icon.svg";
import { GTM_TAGS, PARTNER_DETAILS } from "../../utils/constants";
import { gtmEventTrack } from "../../utils/utilities";
import Button from "../common/Button";

import "./chat.scss";

const Chat = () => {
  useEffect(() => {
    loadScript();
  }, []);

  const handleGTM = () => {
    if (
      GTM_TAGS[process.env.GATSBY_PARTNER] &&
      GTM_TAGS[process.env.GATSBY_PARTNER][process.env.GATSBY_COUNTRY] &&
      GTM_TAGS[process.env.GATSBY_PARTNER][process.env.GATSBY_COUNTRY].LIVE_CHAT
    ) {
      console.log('chat click..')
      gtmEventTrack({
        ...GTM_TAGS[process.env.GATSBY_PARTNER][process.env.GATSBY_COUNTRY]
          .LIVE_CHAT.CLICK,
        action: "Live_Chat",
      });
    }
  };

  const getChatHeader = () => {
    switch (process.env.GATSBY_PARTNER) {
      case PARTNER_DETAILS.SAMSUNG:
        return 'SAMSUNG Care+';
      case PARTNER_DETAILS.SHOPEE:
        return 'Hi there!';
      case PARTNER_DETAILS.ELECBOY:
        return 'ElecBoy Live Chat!';
      default:
        return 'bolttech Live Chat!';
    }
  }

  const loadScript = () => {
    const scripts = [
      `https://${process.env.GATSBY_CLOUDFRONT_ID}.cloudfront.net/js/amazon-connect-chat-interface.js`,
      `https://${process.env.GATSBY_CLOUDFRONT_ID}.cloudfront.net/js/chatWidget.js`,
    ]; //AMS Philippines
    for (let i = 0; i < scripts.length; i++) {
      let node = document.createElement("script");
      node.src = scripts[i];
      node.type = "text/javascript";
      node.async = false;
      node.charset = "utf-8";
      document.getElementById("chatScriptWrapper").appendChild(node);
    }
  };

  const getChatIcon = () => {
    if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.SAMSUNG) {
      return <img id="startChat" src={samsungChatIcon} alt="chat" width={48} height="auto" />
    } else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.SHOPEE) {
      return <img id="startChat" src={shopeeChatIcon} alt="chat" width={48} height="auto" />
    } else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.ELECBOY) {
      return <img id="startChat" src={elecboyChatIcon} alt="chat" width={48} height="auto" />
    } else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.HOMECREDIT) {
      return <img id="startChat" src={hcChatIcon} alt="chat" width={65} height="auto" />
    } else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.HOMECREDIT_ID) {
      return <img id="startChat" src={hcChatIcon} alt="chat" width={65} height="auto" />
    }else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.EIR) {
      return ''
    } else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.TRE) {
      return <img id="startChat" src={treChatIcon} alt="chat" width={48} height="auto" />
    } else if (process.env.GATSBY_PARTNER === PARTNER_DETAILS.EPIC) {
      return <img id="startChat" src={epicChatIcon} alt="chat" width={48} height="auto" />
    }
    return <img id="startChat" src={chatIcon} alt="chat" width={60} height="auto" />
  }

  return (
    <>
      <Helmet>
        <script type="text/javascript">
          {`${(window.chatConfig = {
            headerText: getChatHeader(),
            chatDescription: {
              initial: "Waiting for an agent to respond...",
              agentJoining: "An agent is joining the chat",
              agentChatting: "You are now chatting with ",
            },
            getCustomerName: () => `${process.env.GATSBY_PARTNER} customer`, // an optional customfunction to return the customer's firstname if available
            environment: {
              region: process.env.GATSBY_AWS_REGION_ID, // do not change!
              apiGatewayEndpoint: `https://${process.env.GATSBY_API_GATEWAY_ENDPOINT}.execute-api.${process.env.GATSBY_AWS_REGION_ID}.amazonaws.com/Prod`, //EMEA Prod
              contactFlowId: process.env.GATSBY_CONTACT_FLOW_ID,
            },
            widgetContainerId: "root",
            startButtonId: "startChat",
          })}`}
        </script>
      </Helmet>
      <Button
        className="chat-btn live-chat"
        handleClick={() => handleGTM()}
      >
        {getChatIcon()}
      </Button>
      <section id="section-chat" className="hidden sectionChat">
        <div id="chatWrapper">
          <div id="root" className="root"></div>
        </div>
        <div>
          <div
            id="chatSpinner"
            className="spinner loading loading_spinner"
          ></div>
          <div id="chatScriptWrapper"></div>
        </div>
      </section>
    </>
  );
};

export default Chat;
